import React from "react";
import { Dialog } from "primereact/dialog";
import { TabView, TabPanel } from "primereact/tabview";

import EstantesScreen from "../../Suministros/Estantes/EstantesScreen";
import PosicionesScreen from "../../Suministros/Posiciones/PosicionesScreen";
import BandejaScreen from "../../Suministros/Bandeja/BandejaScreen";

const UbicacionesCrudModal = ({ visible, onHide }) => {
  return (
    <Dialog
        header="Administrar Ubicaciones"
        visible={visible}
        onHide={onHide}
        maximizable
        appendTo={document.body}
        baseZIndex={9000}
        style={{ width: "95vw", height: "90vh" }}
        >
        <TabView style={{ height: "100%" }}>
            <TabPanel header="Estantes">
            <div style={{ height: "calc(90vh - 150px)", overflow: "auto" }}>
                <EstantesScreen enModal />
            </div>
            </TabPanel>

            <TabPanel header="Filas">
            <div style={{ height: "calc(90vh - 150px)", overflow: "auto" }}>
                <PosicionesScreen enModal />
            </div>
            </TabPanel>

            <TabPanel header="Posiciones">
            <div style={{ height: "calc(90vh - 150px)", overflow: "auto" }}>
                <BandejaScreen enModal />
            </div>
            </TabPanel>
        </TabView>
    </Dialog>
  );
};

export default UbicacionesCrudModal;